import { defineMessages } from 'react-intl';

export default defineMessages({
  submissionFailure: {
    id: 'submissionFailure',
    description: 'submissionFailure',
    defaultMessage: 'Your order was not submitted. Please try again.',
  },
  backToDashboardString: {
    id: 'backToDashboard',
    description: 'back to dashboard',
    defaultMessage: 'Back to Dashboard',
  },
});
